module.exports = __webpack_public_path__ + "img/logo.e6706f83.png";